export default __webpack_public_path__ + "static/media/244.db5a1e8d.jpg";